import React from "react";
import Home from './Pages/Home.js';
import { ThemeProvider } from "@mui/material";
import theme from "./theme";

function App() {
    return (
        <ThemeProvider theme={theme}>
            <div style={{
                padding: 0, margin: 0
            }}>
                <Home />
            </div >
        </ThemeProvider>
    );
}

export default App;